
import configs from "@/i18n/configs"
export default {
    today: 'Today',
    'filter': 'Filter',
    'tabs': {
        'doctor': `${configs.doctor.en}`,
        'pharmacy': `${configs.pharmacy.en}`,
        'center': `${configs.center.en}`
    },
    'add-visit': 'Add visit',
    'the-visit': 'the visit'
}